import * as actions from "./actionTypes";
import * as config from "config";

export function getAllAdmin(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetAllAdmin,
            method: "post",
            data: params,
            onStart: actions.GET_ALL_ADMIN_START,
            onSuccess: actions.GET_ALL_ADMIN,
            onError: actions.GET_ALL_ADMIN_FAILED,
            // useLoginJwt: false,
        },
    }
}

export function getAdmin(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiGetAdmin + id,
            method: "get",
            data: {},
            onStart: actions.GET_ADMIN_START,
            onSuccess: actions.GET_ADMIN,
            onError: actions.GET_ADMIN_FAILED,
        },
    }
}

export function createAdmin(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiCreateAdmin,
            method: "post",
            data: params,
            onStart: actions.CREATE_ADMIN_START,
            onSuccess: actions.CREATE_ADMIN,
            onError: actions.CREATE_ADMIN_FAILED,
        },
    }
}

export function resetAdminCreateSuccess() {
    return {
        type: actions.CREATE_ADMIN_RESET,
        payload: {},
    }
}

export function resetReloadPage() {
    return {
        type: actions.RELOAD_PAGE_RESET,
        payload: {},
    }
}

export function editAdmin(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiUpdateAdmin + id,
            method: "put",
            data: params,
            onStart: actions.UPDATE_ADMIN_START,
            onSuccess: actions.UPDATE_ADMIN,
            onError: actions.UPDATE_ADMIN_FAILED,
        },
    }
}

export function resetAdminEditSuccess() {
    return {
        type: actions.UPDATE_ADMIN_RESET,
        payload: {},
    }
}

export function updateAdminStatus(id, status) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiUpdateAdminStatus + id + "/status",
            method: "post",
            data: {
                status: status
            },
            onStart: actions.UPDATE_ADMIN_STATUS_START,
            onSuccess: actions.UPDATE_ADMIN_STATUS,
            onError: actions.UPDATE_ADMIN_STATUS_FAILED,
        },
    }
}

export function deleteAdmin(id) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiDeleteAdmin + id,
            method: "delete",
            data: {},
            onStart: actions.DELETE_ADMIN_START,
            onSuccess: actions.DELETE_ADMIN,
            onError: actions.DELETE_ADMIN_FAILED,
        },
    }
}

export function resendInvite(email) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiAdminResendInvite + email,
            method: "get",
            data: {},
            onStart: actions.RESEND_INVITE_START,
            onSuccess: actions.RESEND_INVITE,
            onError: actions.RESEND_INVITE_FAILED,
        },
    }
}

export function adminOnboard(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiAdminOnboard,
            method: "post",
            data: {
                _id: params.id,
                adminToken: params.adminToken,
                password: params.password,
                confirmPassword: params.confirmPassword,
            },
            onStart: actions.ADMIN_ONBOARD_START,
            onSuccess: actions.ADMIN_ONBOARD,
            onError: actions.ADMIN_ONBOARD_FAILED
        }
    }
}

export function subAccountAdminOnboard(params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiSubAccountAdminOnboard,
            method: "post",
            data: params,
            onStart: actions.ADMIN_ONBOARD_START,
            onSuccess: actions.ADMIN_ONBOARD,
            onError: actions.ADMIN_ONBOARD_FAILED
        }
    }
}

export function resetAdminOnboard() {
    return {
        type: actions.ADMIN_ONBOARD_RESET,
        payload: {},
    }
}

export function adminAssignBusiness(id, params) {
    return {
        type: config.apiRequestStart,
        payload: {
            url: config.apiAdminAssignBusiness + id + "/update-alias",
            method: "post",
            data: params,
            onStart: actions.ADMIN_ASSIGN_BUSINESS_START,
            onSuccess: actions.ADMIN_ASSIGN_BUSINESS,
            onError: actions.ADMIN_ASSIGN_BUSINESS_FAILED,
        },
    }
}
